import { RecordValueSourceConfigurationPage } from "#batteries-included-components/Layouts/RecordConfiguration";
import { useNavigate, useParams } from "#routers/hooks";
import { EquipmentRecordValueSourceRoutePath } from "#routes/organization/equipment/[equipmentId]/record-details/[recordId]/value/[measurementType]/add-source/index";
import {
  EquipmentContext,
  EquipmentProvider,
} from "#src/contexts/EquipmentContext";
import { RecordContext, RecordProvider } from "#src/contexts/RecordContext";
import { useBreadcrumbsFromRoute } from "#src/utils/route";
import { useQuery } from "@tanstack/react-query";
import { MeasurementsDomain } from "@validereinc/domain";
import { yearMonthName } from "@validereinc/utilities";
import React, { useContext } from "react";
import { EquipmentRecordValueDetailRoutePath } from "../index";

const EquipmentRecordValueSourcePageContent = () => {
  const navigate = useNavigate();
  const params =
    useParams<
      Exclude<typeof EquipmentRecordValueDetailRoutePath.pathParams, undefined>
    >();
  const { equipment } = useContext(EquipmentContext) ?? {};
  const { record } = useContext(RecordContext) ?? {};

  const { data: measurementTypes } = useQuery({
    queryKey: ["measurementTypes"],
    queryFn: MeasurementsDomain.listMeasurementTypes,
  });
  const measurementType = measurementTypes?.find(
    ({ id }) => id === params.measurementType
  );

  const recordPageTitle = record
    ? `${yearMonthName(record.year_month)} Record`
    : undefined;

  const recordValuePageTitle = record
    ? `${yearMonthName(record.year_month)} ${measurementType?.name}`
    : EquipmentRecordValueDetailRoutePath.title;

  const [breadcrumbs] = useBreadcrumbsFromRoute(
    EquipmentRecordValueSourceRoutePath,
    {
      "/:equipmentId/detail": {
        title: equipment?.name,
      },
      "/:recordId": {
        title: recordPageTitle,
      },
      "/:measurementType": {
        title: recordValuePageTitle,
      },
    }
  );

  return (
    <RecordValueSourceConfigurationPage
      pageProps={{
        title: recordValuePageTitle,
        category: "Configure Source",
        breadcrumbs,
      }}
      onClose={() => {
        navigate(
          EquipmentRecordValueDetailRoutePath.toLinkParts({
            pathParams: {
              equipmentId: params.equipmentId,
              recordId: params.recordId,
              measurementType: params.measurementType,
            },
          })
        );
      }}
    />
  );
};

export const EquipmentRecordValueSourcePage = () => (
  <EquipmentProvider>
    <RecordProvider>
      <EquipmentRecordValueSourcePageContent />
    </RecordProvider>
  </EquipmentProvider>
);
